/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pageurl } from 'utils/environment';



// <<<<<<<<<<<<<<<<<<<<<< ---------------------- CUSTOM CONSOLE LOGGER ---------------------- >>>>>>>>>>>>>>>>>>>>> //
const log = pageurl.includes('showLogs=true') ? console.log.bind(window.console) : function(){};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { log };